import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getReportsQualityControls(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REPORTS_QUALITY_CONTROLS,
		ModulesConfigMap[ModulesMap.REPORTS_QUALITY_CONTROLS].GET_REPORTS_QUALITY_CONTROLS,
		options
	)
}

function _getReportsQualityControl(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REPORTS_QUALITY_CONTROLS,
		ModulesConfigMap[ModulesMap.REPORTS_QUALITY_CONTROLS].GET_REPORTS_QUALITY_CONTROL,
		options
	)
}

function _getReportsQualityControlPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REPORTS_QUALITY_CONTROLS,
		ModulesConfigMap[ModulesMap.REPORTS_QUALITY_CONTROLS].GET_REPORTS_QUALITY_CONTROL_PREVIEW,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.REPORTS_QUALITY_CONTROLS].GET_REPORTS_QUALITY_CONTROLS]: _getReportsQualityControls,

	[ModulesConfigMap[ModulesMap.REPORTS_QUALITY_CONTROLS].GET_REPORTS_QUALITY_CONTROL]: _getReportsQualityControl,

	[ModulesConfigMap[ModulesMap.REPORTS_QUALITY_CONTROLS].GET_REPORTS_QUALITY_CONTROL_PREVIEW]:
		_getReportsQualityControlPreview,
}
